export default __webpack_public_path__ + "f7c084b9af1ffb592b805faa410596da.png";